export const adminPath = {
  /* inject path */
  NEWS: '/admin/news-logs-table',
  ELASTICSEARCH_INDEXES: '/admin/elasticsearch-indexes',
  SOURCE_TABLE: '/admin/sources-table',
  COMPARE_SCOURCES: '/admin/compare-scources',
  DASHBOARD: '/admin/dashboard',
};
